/** Strict encoding checks detect damaged local artifacts; they do not authenticate them. */
function decodeDataUrl(value: string, mime: string) {
  const prefix = `data:${mime};base64,`
  if (!value.startsWith(prefix)) throw new Error('Invalid artifact type')
  const encoded = value.slice(prefix.length)
  if (!encoded || encoded.length % 4 !== 0) throw new Error('Invalid artifact encoding')
  const binary = atob(encoded)
  if (btoa(binary) !== encoded) throw new Error('Invalid artifact encoding')
  return binary
}

export function isStoredPng(value: string) {
  try {
    const binary = decodeDataUrl(value, 'image/png')
    return (
      binary.startsWith('\x89PNG\r\n\x1a\n') && binary.endsWith('\x00\x00\x00\x00IEND\xaeB\x60\x82')
    )
  } catch {
    return false
  }
}

export async function assertUsablePdf(value: string) {
  const binary = decodeDataUrl(value, 'application/pdf')
  const trailer = /startxref\s+(\d+)\s+%%EOF\s*$/.exec(binary)
  if (!/^%PDF-1\.[0-7]/.test(binary) || !trailer || Number(trailer[1]) >= binary.length)
    throw new Error('Incomplete PDF')
  const { PDFDocument } = await import('pdf-lib')
  const pdf = await PDFDocument.load(
    Uint8Array.from(binary, (character) => character.charCodeAt(0)),
    {
      throwOnInvalidObject: true,
      updateMetadata: false,
    },
  )
  if (
    !pdf.getPageCount() ||
    pdf.getPages().some((page) => page.getWidth() <= 0 || page.getHeight() <= 0)
  )
    throw new Error('Invalid PDF pages')
}
